import React from 'react';
import Spinner from '../Spinner/Spinner';
import {LoadingIndicatorProps} from '../../@types/components/LoadingIndicator';
import classnames from '../../helpers/classnames';

export default function LoadingIndicator(props: LoadingIndicatorProps) {
    const {type, color, className, ...rest} = props;
    if (type !== 'linear') {
        return <Spinner {...props}/>;
    }

    return <div className={classnames({
        'linear-loading-indicator': true,
        [className ?? '']: className,
        [`linear-loading-indicator--${color}`]: color
    })} {...rest}>
        <div className="linear-loading-indicator__slider"/>
        <div className="linear-loading-indicator__slider"/>
    </div>;
}
